<template>
<div>
	<ihead :checkindex="checkindex"></ihead>
	<div class="banner-box">		
		<h1>大事记</h1>
	</div>
	<mu-container>
			<mu-breadcrumbs>
				<mu-breadcrumbs-item
					v-for="(item, index) in items"
					:key="index"
					:to="item.to"
					:disabled="item.disabled"
					>{{ item.text }}</mu-breadcrumbs-item
				>
			</mu-breadcrumbs>
		</mu-container>
	  <div class="content">
      <div class="wrapper warp">
        <hr class="line-left" />
        <hr class="line-right" />
        <div class="main">
          <h1 class="titlemain">研究院大事记</h1>
          <div class="year" v-for="item in timerList" :key='item.id'>
            <h2>
              <a href="#" @click="hideTimer($event)">{{item.year}}年<i></i></a>
            </h2>
            <div class="list">
              <ul>
                <li class="cls highlight" v-for="itemlist in item.list" :key='itemlist.id'>
                  <p class="date">{{itemlist.memorabilia_time}}</p>
                  <a :href="'/institution-article?id=' + itemlist.id + '&mainid=' + mainid + '&subid=' + subid "><p class="intro">{{itemlist.title}}</p>
                    <p class="version">&nbsp;</p>
                    <div class="more">
                      <p>{{itemlist.description}}</p>                   
                    </div>
                  </a>
                  <!-- <p class="version">&nbsp;</p>
                  <div class="more">
                    <p>{{itemlist.description}}</p>                   
                  </div> -->
                </li>                
              </ul>
            </div>
          </div>         
        </div>
      </div>
    </div>
	<div class="clearfix"></div> 
	<ifoot></ifoot>  
	<returntop class="return-top"></returntop>
</div>   
</template>

<script>
import '../assets/css/timer.css'
import ihead from "@/components/ihead.vue"
import ifoot from '@/components/ifoot.vue'
import crumbs from "@/components/crumbs.vue"
import returntop from '@/components/returntop'
export default {
	components: {
		ihead,ifoot,crumbs,returntop
	},
	name:'timer',
	data() {
  let that = this
	return {
    id: this.$route.query.id,
    checkindex:1,
    mainid: this.$route.query.mainid,
    subid: this.$route.query.subid,
		items:[{
			text: '首页',
			disabled: false
		}, {
			text: '机构设置',
			disabled: false
		}, {
			text: '大事记',
			disabled: true
    }],	
    timerList:[]	
	}
},
	created(){  
    this.getTimerList(15,1,10)
	},
  methods:{   
    hideTimer(e){
        var list = e.currentTarget.parentElement.nextElementSibling;      
        var $target = $(list)
        var $ul = $target.find("ul");
        $target.height($ul.outerHeight()), $ul.css("position", "absolute");
        // console.log($ul.outerHeight())
        $(e.target).parents(".year").toggleClass("close");         
      },
      getTimerList(cid,page,offset){   
        var data = {
          cid:this.id,
          page:1,
          offset:10000
        }
      this.$get('/article/get-memorabilia-list',data).then(res => {
				if(res.code == 0){	
          var data = res.data;         
          var dataLength = Object.keys(data).length;       
          for(var j = 0;j<dataLength;j++){
            // console.log(Object.values(data)[j])
            for(var k = 0;k<Object.values(data)[j].length;k++){              
              Object.values(data)[j][k].memorabilia_time = Object.values(data)[j][k].memorabilia_time.split('-')[1]+'月'+Object.values(data)[j][k].memorabilia_time.split('-')[2]+'日'
            }
          }                       
          for(var i = dataLength-1;i>=0;i--){                  
            this.timerList.push({year:Object.keys(data)[i],list:Object.values(data)[i]})          
          }          
				}else{
					// console.log(res.message)					
				}			
			})
    }
  }
}
</script>
<style>  
@media screen and ( max-width: 768px){
  .content .line-left{
    width: 10%;
  }
  .content .line-right{
    width: 10%;
  }
  .content .main .year h2{
    width: 25%;
    font-size: 16px;
  }
  .content .main .year h2 i{
    left: 100%;
    font-size: 14px;
  }
  .content .main .titlemain{
    left: 30%;
    font-size: 16px;    
    background: url(/static/img/timer.331c1de8.png) no-repeat 0 top;
    background-size: 40px;
  }
  .content .main{
    background: url(https://www.17sucai.com/preview/1/2014-04-08/%E6%97%B6%E9%97%B4%E8%BD%B4/images/log/line-bg.png) repeat-y 35% 0;
  }
  .content .main .year .list ul li{
    background: url(/static/img/dian.c5e8ff6b.png) no-repeat 34% 31px;
  }
  .content .main .year .list ul li .date, .content .main .year .list ul li .version{
    width: 26%;
  }
  .content .main .year .list ul li .intro, .content .main .year .list ul li .more{
    width: max-content;
  }
  .content .main .year .list ul li .more {
    margin-left: 45%;
    overflow:hidden;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:3;
    width: 50%;
  }
  .year .list ul{
    width: 100%;
  }
  .content .main .year .list ul li .intro{
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      width: 45%;
  }
}
@media screen and ( max-width: 320px) {		
  .content .main .year .list ul li .intro{      
      width: 40%;
  }	
}
</style>
